/**
 * Tick de dégâts combat — registre module (survit à combat.reset() / $reset Pinia).
 * useCombatLoop enregistre la logique ; useCombatStore l’invoque à chaque seconde.
 */
let combatDamageTick: (() => void) | null = null

export function registerCombatDamageTick(fn: () => void): void {
  combatDamageTick = fn
}

export function runCombatDamageTick(): boolean {
  if (!combatDamageTick) return false
  combatDamageTick()
  return true
}

export function hasCombatDamageTick(): boolean {
  return combatDamageTick !== null
}
